import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ajaxNewMwebPreUrl } from '@/config';
import axios from 'axios';
import User from 'drip/user';
import { isProd } from '@/utils/openApp';
export var getShowInfoApi = /*#__PURE__*/function () {
  var _getShowInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/shows"), {
            projectId: id
          });
        case 2:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getShowInfo(_x) {
    return _getShowInfo.apply(this, arguments);
  }
  return getShowInfo;
}();
export var getCalendarTag = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return axios.get("".concat(ajaxNewMwebPreUrl, "/calendar/tag"));
        case 2:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getCalendarTag() {
    return _ref.apply(this, arguments);
  };
}();
export var getJumpInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var projectId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          projectId = _ref2.projectId;
          _context3.next = 3;
          return axios.get("".concat(ajaxNewMwebPreUrl, "/project/jumpInfo?projectId=").concat(projectId, "&detailType=1"));
        case 3:
          return _context3.abrupt("return", _context3.sent);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getJumpInfo(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var getDateCardApi = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/shows/dateCard"), {
            projectId: projectId
          });
        case 2:
          return _context4.abrupt("return", _context4.sent);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getDateCardApi(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var taskReportApi = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var baseUrl, queryString, url;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          baseUrl = "https://".concat(isProd ? 'api.maoyan.com/sns' : 'm.51ping.com/api/sns', "/user/view.json");
          queryString = new URLSearchParams(params).toString();
          url = queryString ? "".concat(baseUrl, "?").concat(queryString) : baseUrl;
          _context5.next = 5;
          return axios({
            url: url,
            method: 'post',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded',
              'Token': User.token
            }
          });
        case 5:
          return _context5.abrupt("return", _context5.sent);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function taskReportApi(_x4) {
    return _ref5.apply(this, arguments);
  };
}();